module.exports = __webpack_public_path__ + "static/dcom2-5791e7a8531a438305e33b9fdd11bc68.png";